module.exports = "/packs/media/images/module-healthcare-1b6488cc9715c5ba18ba60e91ddd2005.png";